import styled from 'styled-components'

const Container = styled.div``

const CreationSourceEditorFiltersPanel = () => {
    return <Container>Filters</Container>
}

export default CreationSourceEditorFiltersPanel
